import React from 'react';
import PropTypes from 'prop-types';

import RenderTemporary from '../../RenderTemporary';
import AlertBox from './AlertBox';

import { enhance } from './enhance';
import styles from './index.styl';

const AppAlert = ({
  errorMessage,
  iconType,
  infoErrorIcon,
  isStaticFlow,
  message,
  title,
  update,
  updateError,
  values,
}) => {
  const updateSuccessMsg = () => {
    if (errorMessage && updateError) updateError();
    if (message && update) update();
  };

  return isStaticFlow ? (
    <AlertBox
      onClose={updateSuccessMsg}
      type="error"
      text={errorMessage}
      showBtn
      infoErrorIcon={infoErrorIcon}
      title={title}
    />
  ) : (
    <RenderTemporary
      rendered={!!errorMessage || !!message}
      timeout={4000}
      callback={updateSuccessMsg}
    >
      <AlertBox
        {...{ iconType }}
        title={title}
        type={errorMessage ? 'error' : 'success'}
        text={errorMessage || message}
        values={values}
        onClose={updateSuccessMsg}
        dialogClassName={styles.dialog}
      />
    </RenderTemporary>
  );
};

AppAlert.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ]),
  update: PropTypes.func,
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ]),
  updateError: PropTypes.func,
  iconType: PropTypes.string,
  values: PropTypes.object,
  title: PropTypes.string,
  isStaticFlow: PropTypes.bool,
  infoErrorIcon: PropTypes.string,
};

AppAlert.defaultProps = {
  errorMessage: null,
  updateError: null,
  update: null,
  message: null,
  iconType: null,
  title: null,
};

export default enhance(AppAlert);



// WEBPACK FOOTER //
// ./src/components/common/AppAlert/index.jsx